'use client';

import styled from 'styled-components';

export const QuoteBlockContainer = styled.div`
  text-align: center;
`;

export const QuoteText = styled.p`
  font-style: italic;
`;

export const QuoteAuthor = styled.p`
  font-weight: bold;
`;
